module.exports = __webpack_public_path__ + "img/madnessBanner_1248.b6895e92.png";